import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { EventLogActions, EventLogStoreState } from 'src/app/store/event-log-store';
import { Store as NgxsStore } from '@ngxs/store';
import { Login } from 'src/app/state/snappstay.action';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private eventLogStore: Store<EventLogStoreState.State>,
    private router: Router,
    private ngxsStore: NgxsStore,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!(error instanceof HttpErrorResponse)) {
          return throwError(() => new Error(error));
        }
        if (error.url.includes('ignoreIfError') && error.status >= 400 && error.status < 500) {
          return throwError(() => error);
        }
        if (error.status === 401 || error.status > 401 || error.status === 400) {
          if (typeof error?.error === 'object' && !Array.isArray(error?.error) && !error?.error?.message) {
            // Handle dynamic object with field names as keys and error arrays as values
            // e.g., { "Status": ["error message"], "Remarks": ["error message"] }
            if (!error.url.includes('GetMyProfile')) {
              let errorMessages: string[] = [];
              Object.keys(error.error).forEach((fieldName) => {
                const fieldErrors = error.error[fieldName];
                if (Array.isArray(fieldErrors)) {
                  fieldErrors.forEach((errorMsg) => {
                    errorMessages.push(`${fieldName}: ${errorMsg}`);
                  });
                } else {
                  errorMessages.push(`${fieldName}: ${fieldErrors}`);
                }
              });
              const formattedMessage = errorMessages.join(' | ');
              this.eventLogStore.dispatch(new EventLogActions.Error(formattedMessage));
            }
          } else {
            if (!error.url.includes('GetMyProfile')) {
              if (error?.error?.message && typeof error?.error?.message === 'string') {
                this.eventLogStore.dispatch(new EventLogActions.Error(`Error: ${error.error.message}`));
              } else {
                this.eventLogStore.dispatch(new EventLogActions.Error(`${error.message}`));
              }
            }
          }
        }

        /**
         * P.S.
         * error.status is used to in auth.service.ts
         * to check if refreshShouldHappen
         */
        if (request.method === 'GET' && error.status === 401) {
          if (!error.url.includes('GetMyProfile')) {
            this.logout();
          }
        }
        return throwError(() => error);
      }),
    );
  }

  logout() {
    this.ngxsStore.dispatch(new Login(undefined));
    this.ngxsStore.reset({});
    this.router.navigate(['/'], {
      replaceUrl: true,
    });
  }
}
